import React, { useEffect, useRef } from "react";
import "./DLSDropdown.scss";
import { IDSSDropdownProps } from "../../building-blocks/DSSFramework";
import Select from "./Select/Select";

export const DLSDropdown = (props: IDSSDropdownProps) =>
{

    const dropdownref = useRef<HTMLDivElement | null>(null);

 


    return (
        <div className={ `dropdown` } style={ props.style } ref={ dropdownref }>
            { props.label && (
                <label className={ `dropdown-label ${ props.disabled ? 'disabled' : '' }` }>
                    { props.label }
                    { !props.disabled && props.required ? <span className="required-asterisk">   Required</span> : <span className="required-asterisk"></span> }
                </label>
            ) }

            <div className="dropdown-wrapper">
                <Select  { ...props } />
            </div>

        </div>
    );
};